import React, { useEffect, useState } from 'react';
import { Modal, Select, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { getTemplates } from '../../requests/templates';

const { Option } = Select;

const selector = (state) => ({
  user: state.user,
  updateBox: state.updateBox,
  boxes: state.boxes,
});

const RecursiveModelConfigModal = ({ boxId, open, onClose }) => {
  const { t } = useTranslation();
  const { user, updateBox, boxes } = useStore(selector);
  const [templates, setTemplates] = useState([]);
  const [selections, setSelections] = useState({});

  const works = user?.works ?? [];
  const box = boxes.find((b) => b.id === boxId);

  const forcedTemplates = box?.content?.forcedTemplates;
  useEffect(() => {
    if (!open) return;
    getTemplates().then((res) => {
      if (res) setTemplates(res);
    });
    if (forcedTemplates) {
      setSelections({ ...forcedTemplates });
    }
  }, [open, forcedTemplates]);

  const opportunityTemplates = templates.filter(
    (t) => t.templatable === 'opportunity' && t.pattern === 'template'
  );

  const handleConfirm = () => {
    updateBox(boxId, (b) => {
      b.content.forcedTemplates = selections;
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t('recursive_model_config_title')}
      footer={[
        <Button key="cancel" onClick={onClose}>{t('cancel')}</Button>,
        <Button key="ok" type="primary" onClick={handleConfirm}>{t('confirm')}</Button>,
      ]}
    >
      <div style={{
        background: '#f0f5ff',
        border: '1px solid #adc6ff',
        borderRadius: 6,
        padding: '10px 14px',
        marginBottom: 20,
        fontSize: 13,
        color: '#1d39c4',
        lineHeight: 1.6,
      }}>
        {t('recursive_model_config_help')}
      </div>
      {works.map((work) => {
        const workTemplates = opportunityTemplates.filter((tpl) => tpl.work === work);
        return (
          <div key={work} style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 4, fontWeight: 500 }}>{t(work)}</div>
            <Select
              style={{ width: '100%' }}
              value={selections[work] ?? null}
              onChange={(val) => setSelections((prev) => ({ ...prev, [work]: val }))}
              allowClear
              // Une agence peut avoir des dizaines de modèles par métier :
              // sans recherche, il ne reste que le défilement.
              showSearch
              optionFilterProp='children'
              filterOption={(input, option) =>
                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
              }
              placeholder={t('recursive_model_ask_on_creation')}
            >
              {workTemplates.map((tpl) => (
                <Option key={tpl.id} value={tpl.id}>{tpl.name}</Option>
              ))}
            </Select>
          </div>
        );
      })}
    </Modal>
  );
};

export default RecursiveModelConfigModal;
